import { useEffect, useState } from 'react';

import {
  DEFAULT_CURRENCY_CODE,
  INCLUDE_HIDDEN_BRANCHES_PARAM
} from '@constants/common';
import { LOCAL_STORAGE_KEYS } from '@constants/storage';
import { useLazyGetAllBranchesQuery } from '@features/branch-management/queries';
import { getLocalStorageItem } from '@utils/storage';
import { Branch } from 'types/branches';
import { DropdownOption } from 'types/dropdown';

const useBranchOptions = () => {
  const organizationId = getLocalStorageItem(
    LOCAL_STORAGE_KEYS.ORGANIZATION_ID
  );
  const [branchOptions, setBranchOptions] = useState<DropdownOption[]>([]);
  const [getAllBranches] = useLazyGetAllBranchesQuery();

  useEffect(() => {
    const fetch = async () => {
      const res = await getAllBranches({
        organizationId,
        queryString: `?currency_code=${DEFAULT_CURRENCY_CODE}&${INCLUDE_HIDDEN_BRANCHES_PARAM}`
      });
      if (res?.data) {
        setBranchOptions(
          res.data.data.map((b: Branch) => ({
            id: b.id,
            label: b.name,
            value: b.id
          }))
        );
      }
    };
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return branchOptions;
};

export default useBranchOptions;
